<template>
  <div>
    <!-- <div>
      <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

    </div> -->
    <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
      <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
      <v-btn dark text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
    <v-card class="box">
      <v-toolbar flat dense class="toolbar">
        <v-toolbar-title>Teacher Abbreviation</v-toolbar-title>
        <v-divider class="mx-4" inset vertical></v-divider>
        <v-spacer></v-spacer>
      </v-toolbar>
      <v-data-table :headers="headers" :items="instructorList" class="elevation-1 mytable" dense :search="search">
        <template v-slot:top>
          <v-toolbar dense flat color="white">
            <!-- <v-toolbar-title>Teacher Abbreviation</v-toolbar-title>
                    <v-divider class="mx-4" inset vertical></v-divider> -->
            <v-spacer></v-spacer>
            <v-text-field v-model="search" append-icon="search" label="Search" single-line hide-details>
            </v-text-field>
            <span style="width: 20px"></span>
            <v-dialog v-model="dialog" max-width="500px">
              <v-card>
                <v-form v-model="valid">
                  <v-card-title class="toolbar">
                    <span class="headline">{{ formTitle }}</span>
                  </v-card-title>

                  <v-card-text>
                    <v-container>
                      <v-row>
                        <v-col cols="12" sm="12" md="12">
                          <v-text-field outlined dense rounded v-model="editedItem.abbreviation" persistent-hint :hint="editedIndex == -1
                            ? 'For example :: DPP, RSP..'
                            : 'For example ::  DPP, RSP..'
                            " label="Enter Teacher Abbreviation" :rules="[(v) => !!v || 'required']">
                          </v-text-field>
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-card-text>

                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn class="button" @click="close">Cancel</v-btn>
                    <v-btn class="button" @click="save" :disabled="!valid">Save</v-btn>
                  </v-card-actions>
                </v-form>
              </v-card>
            </v-dialog>
          </v-toolbar>
        </template>

        <template v-slot:item.action="{ item }">
          <div>
            <v-avatar style="" size="25" class="edit-avatar">
              <v-icon class="edit-v-icon mr-2" @click="editItem(item)">edit</v-icon>
            </v-avatar>
          </div>
        </template>
      </v-data-table>
      <v-overlay :value="overlay">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>
    </v-card>
  </div>
</template>

<script>
import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed

export default {

  components: {
    Breadcrumbs,
  },
  data: () => ({
    overlay: false,
    valid: false,
    // extraBreadcrumbItems: [
     

    // ],
    // breadcrumbClass: "breadcrumb-style1",
    errorMsg: {
      id: false,
    },
    snackbar_msg: "",
    color: "",
    snackbar: false,
    search: "",
    dialog: false,
    headers: [
      {
        text: "Teacher Code",
        align: "left",
        sortable: false,
        value: "employee_code",
      },
      {
        text: "Teacher Name",
        align: "left",
        sortable: false,
        value: "person",
      },
      {
        text: "Abbreviation",
        align: "left",
        sortable: false,
        value: "abbreviation",
      },

      // {
      //   text: 'Active',align: 'left',sortable: true,value: 'isactive',
      // },
      { text: "Actions", value: "action", sortable: false },
    ],
    instructorList: [],
    editedIndex: -1,
    editedItem: {
      id: "",
      employee_code: "",
      person: "",
      abbreviation: "",
      //isactive:true
    },
    defaultItem: {
      id: "",
      employee_code: "",
      person: "",
      abbreviation: "",
      //isactive:true
    },
  }),

  computed: {
    formTitle() {
      return this.editedIndex === -1
        ? "New Teacher Abbreviation"
        : "Edit Teacher Abbreviation";
    },
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
    overlay(val) {
      val = () => {
        this.overlay = false;
      };
    },
  },

  // created () {
  //   this.initialize()
  // },
  mounted() {
    this.onLoad();
  },
  methods: {


    initializeErrorMsgFalse() {
      this.errorMsg.id = false;
    },
    onLoad() {
      this.overlay = true;
      axios
        .post("/TimeTable/timeTableTeacherAbbreviation")
        .then((res) => {
          if (res.data.msg == "200") {
            if ((this.load = true)) {
              this.overlay = false;
              this.instructorList = res.data.instList;
            }
          } else {
            window.console.log(res.data.msg);
          }
        })
        .catch((error) => {
          this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
          window.console.log(error);
        })
        .finally(() => {
          // 'use strict';
          var overlay = false;
        });
    },
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },

    editItem(item) {
      this.editedIndex = this.instructorList.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },
    close() {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },

    save() {
      if (this.editedIndex > -1) {
        axios
          .post("/TimeTable/ediTimeTableTeacherAbbreviation", this.editedItem)
          .then((res) => {
            if (res.data.status == "YES") {

              Object.assign(
                this.instructorList[this.editedIndex],
                this.editedItem
              );
              this.showSnackbar("green", res.data.status_reason);// show snackbar on success
              this.onLoad();

            } else if (res.data.status == "NO") {
              this.showSnackbar("error", res.data.status_reason); // show snackbar on success

            } else {
              this.showSnackbar("error", "Something Went Wrong..!"); // show snackbar on success

            }
          })
          .catch((error) => {
            window.console.log(error);
          });

        this.close();
      } else {
        axios
          .post("/TimeTable/saveTimeTableTeacherAbbreviation", this.editedItem)
          .then((res) => {
            if (res.data.status.code == "SUCCESS") {
              this.instructorList.push(this.editedItem);
              this.showSnackbar(
                "#4caf50",
                "Abbreviation Added Successfully..."
              ); // show snackbar on success
              this.onLoad();
            } else if (res.data.status.code == "NA") {
              this.showSnackbar("#b71c1c", "Abbreviation Already Present!!!"); // show snackbar on error
            }
          })
          .catch((error) => {
            window.console.log(error);
          });
        this.close();
      }
    }, // end of save()

    //   isValidated() {
    //     if (this.editedItem.id) {
    //       return true;
    //     } else {
    //       if (!this.editedItem.id) {
    //         this.errorMsg.id = true;
    //       }

    //       return false;
    //     }
    //   } // .....end of isValidated()
  },
};
</script>
<style scoped>
.v-text-field {
  padding-top: 0px;
  margin-top: 0px;
}

.v-icon-size {
  font-size: 20px;
}

.edit-avatar {
  transition: 0.3s;
  border: 1px solid #b0bec5;
}

.edit-avatar:hover {
  background-color: #b0bec5;
}

.edit-v-icon {
  padding-left: 6px;
  font-size: 15px;
}

.edit-v-icon:hover {
  color: white;
}
</style>
